import { ReactElement, useCallback } from "react";
import styles from "../TagList/TagList.module.less";
import { Tag } from "../Tag/Tag";
import { Dialog } from "../Dialog/Dialog";
import { TagModel } from "../TagSelect/TagSelect";
import {
	convertArbitraryValueForTrackingId,
	generateTrackingId,
	isNotNilOrEmpty,
	setTrackingId
} from "client/Misc/utils";
import classNames from "classnames";

export type TagListDialogProps<TValue> = {
	tags: readonly TagModel<TValue>[];
	title: string;
	onClose: () => void;
	onTagClick?(tag: TValue | null): void;
	trackingId?: string;
};

export const TagListDialog = <TValue, >(props: TagListDialogProps<TValue>): ReactElement => {
	const {
		tags,
		title,
		onClose,
		onTagClick,
		trackingId
	} = props;

	const getValueTrackingId = useCallback(
		(item: TagModel<TValue>): string => {
			if (isNotNilOrEmpty(item.valueTrackingId)) {
				return item.valueTrackingId;
			}

			return convertArbitraryValueForTrackingId(item.value);
		},
		[]
	);

	return (
		<Dialog
			trackingId={trackingId}
		>
			<Dialog.Header title={title} onClose={onClose} />
			<Dialog.Body>
				<ul
					{...setTrackingId(trackingId, "__tag-list")}
					className={classNames(
						styles.root,
						styles.root_wrap
					)}
				>
					{tags.map(((tag, index) => (
						<li
							key={index}
							className={styles.listItem}
						>
							<Tag
								text={tag.text}
								color={tag.color}
								isDisabled={tag.isDisabled}
								trackingId={generateTrackingId("tag", `|${getValueTrackingId(tag)}`)}
								onClick={
									onTagClick
										? () => onTagClick(tag.value)
										: undefined
								}
								highlight={tag.highlight}
							/>
						</li>
					)))}
				</ul>
			</Dialog.Body>
			<Dialog.Footer />
		</Dialog>
	);
};

TagListDialog.displayName = "TagListDialog";